import { formatDistanceToNow, format } from "date-fns";

export const formatRelativeTime = (timestamp: number | string | Date): string => {
  const date = new Date(timestamp);
  return formatDistanceToNow(date, { addSuffix: true });
};

export const formatFullDate = (timestamp: number | string | Date): string => {
  const date = new Date(timestamp);
  return format(date, "do MMMM yyyy, HH:mm");
};

export const formatRunTime = (status: string, startTime?: number, scheduledStartTime?: number): { relative: string, full: string } => {
  const time = status === "SCHEDULED" ? scheduledStartTime : startTime;
  if (!time || time === 0) return { relative: "Now", full: "Now" };
  return {
    relative: formatRelativeTime(time),
    full: formatFullDate(time)
  };
};
